class Diagnostics {
  static CODES = Object.freeze({
    INCOMPLETE_CLAUSE: 'FQL-INCOMPLETE-CLAUSE',
    UNCLOSED_GROUP: 'FQL-UNCLOSED-GROUP',
    UNCLOSED_PHRASE: 'FQL-UNCLOSED-PHRASE',
    UNCLOSED_RANGE: 'FQL-UNCLOSED-RANGE',
    UNSUPPORTED_SYNTAX: 'FQL-UNSUPPORTED-SYNTAX',
    DANGLING_OPERATOR: 'FQL-DANGLING-OPERATOR',
    EMPTY_GROUP: 'FQL-EMPTY-GROUP',
    TOO_DEEP: 'FQL-TOO-DEEP',
    BARE_TERM: 'FQL-BARE-TERM',
    UNKNOWN_FIELD: 'FQL-UNKNOWN-FIELD',
    COERCION_FAILED: 'FQL-COERCION-FAILED',
    VALUE_NOT_IN_ENUM: 'FQL-VALUE-NOT-IN-ENUM',
    WILDCARD_NOT_ALLOWED: 'FQL-WILDCARD-NOT-ALLOWED',
    CLAUSE_SKIPPED: 'FQL-CLAUSE-SKIPPED'
  });

  static error(code, message, span) {
    return { code, severity: 'error', message, span: { start: span.start, end: span.end } };
  }

  static warning(code, message, span) {
    return { code, severity: 'warning', message, span: { start: span.start, end: span.end } };
  }
}

export { Diagnostics };
export default Diagnostics;
